import React from 'react';
export var InfinityIcon = function InfinityIcon() {
  return React.createElement("i", {
    className: "fal fa-infinity"
  });
};